import { Controller } from "@hotwired/stimulus"

// Sortable owns the gesture and persistence queue; this controller knows
// only the Activity board's rendering contract. The server returns the
// canonical Card face after a move so status, audience and activity time do
// not stay stale in the optimistic DOM.
export default class extends Controller {
  persisted({ detail: { item, response } }) {
    const face = item?.querySelector("[data-activity-board-face]")
    if (face && response?.face) face.innerHTML = response.face
  }
}
